import axios from 'axios';
import { Message, MessageBox } from 'element-ui';
import download from '@xy/download';
import Cookies from 'js-cookie';
import { getToken } from '@/utils/auth';
import clientConfig from '../config';
import { Loading } from 'element-ui';
import store from '@/store';
// import vueSentry from '@xy/sentry-vue';

// create an axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    withCredentials: true, // send cookies when cross-domain requests
    // timeout: 5000 // request timeout
});

const loading = {
    instance: null,
    id: null,
    show: id => {
        // 总是存在最后一个loading
        loading.id = id;
        loading.instance =
            loading.instance ||
            Loading.service({
                fullscreen: false,
                target: document.querySelector('.app-main'),
            });
    },
    close: id => {
        if (id === loading.id) {
            loading.instance.close();
            loading.instance = null;
            loading.id = null;
        }
    },
};

const SingleMsgBox = () => {
    let hasInstance = false;
    return (...args) => {
        if (hasInstance) return;
        hasInstance = true;
        return MessageBox(...args).then(res => {
            hasInstance = false;
            return res;
        });
    };
};

const singleNotLoginMsgBox = SingleMsgBox();

/**
 * 返回带前缀的url
 * @param {string} url 接口地址
 * @param {string} prefix business | bookingAdmin
 * @returns 新的地址
 */
const generatePrefixUrl = (url, prefix) => {
    if (
        // 同时不存在这两种前缀时，则自动处理
        !url.includes('/bookingAdmin/') &&
        !url.includes('/business/') &&
        // 自定义服务
        !url.includes('/custom-system/')
    ) {
        // 接口前缀，默认走business
        let urlPrefix = 'business';
        // 是否自定义前缀
        if (prefix) {
            urlPrefix = prefix;
        }
        // 请求url
        url = '/' + urlPrefix + url;
    }

    // 开发环境
    if (process.env.NODE_ENV === 'development') {
        const mockApiList = require('../../mock').default;
        console.warn('mockApiList :>> ', mockApiList);
        // mock数据
        if (mockApiList && mockApiList.trim()) {
            const mockList = mockApiList.split(/\n|;/).map(item => item.trim()).filter(item => item);
            const mockIndex = mockList.findIndex(mockApi => mockApi.endsWith(url));
            if (mockIndex !== -1) {
                // 使用mockApi
                return mockList[mockIndex].trim();
            }
        }
    }

    return url;
};

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent
        config.headers = Object.assign({}, getCommonHeaders(), config.headers);
        config._xhrId = utils.genId();
        let { method, data, url } = config;
        if (url.includes('/bookingAdmin/')) {
            // 嵌入yyStoreId
            if (method === 'post') {
                if (!data) {
                    config.data = { yyStoreId: store.getters.yyStoreId };
                } else {
                    !data.yyStoreId && (data.yyStoreId = store.getters.yyStoreId);
                }
            } else if (method === 'get') {
                if (!url.includes('yyStoreId')) {
                    url = url.includes('?')
                        ? `${url}&storeId=${store.getters.yyStoreId}`
                        : `?storeId=${store.getters.yyStoreId}`;
                }
            }
        }

        if (config.showLoading) {
            loading.show(config._xhrId);
        }

        console.log('config')
        console.log(config)
        config.url = generatePrefixUrl(config.url, config.urlPrefix);
        console.log('url', config.url)
        return config;
    },
    error => {
        // do something with request error
        console.log(error); // for debug
        return Promise.reject(error);
    }
);

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    async response => {
        loading.close(response.config._xhrId);
        // 是否登录失效
        const { status } = response.data;
        if ([610, 100].includes(status)) {
            // singleNotLoginMsgBox({
            //     type: 'info',
            //     message: '您的登录状态已失效，请重新登录',
            //     closeOnClickModal: false,
            //     confirmButtonText: '重新登录',
            // }).then(() => {
            //     store.dispatch('user/logout').then(t => (location.href = '/login'));
            // });
            return;
        }

        // 自动捕获业务层错误
        if (response.config.catchBusinessErr) {
            if (!response.data.success) {
                Message({
                    message: response.data.message || '请求发生错误',
                    type: 'error',
                    duration: 2 * 1000,
                });
                return Promise.reject(response.data.message);
            }
        }
        return response;
    },
    error => {
        // try {
        //     const json = JSON.stringify(error);
        //     vueSentry.captureMessage('接口错误上报:' + json);
        //   } catch (error) {}
        // 主动cancel先挂起promise
        if (error.constructor.name === 'Cancel') {
            return new Promise(r => { });
        }
        loading.close(error.config._xhrId);
        Message({
            message: error.msg || '请求发生错误',
            type: 'error',
            duration: 2 * 1000,
        });
        return Promise.reject(error);
    }
);

export const get = (url, data = {}, options = {}) => {
    const opt = { autoDealError: true, ...options };
    return service({
        url: url,
        method: 'get',
        params: { ...(data.params || data), t: +new Date() },
        ...opt,
    });
};

export const getInternalReqUrl = url => `${process.env.VUE_APP_BASE_API}${url}`;

export const post = (url, data, options = {}) => {
    const opt = { autoDealError: true, ...options };
    return service({
        url: url,
        method: 'post',
        data,
        ...opt,
    });
};

export const put = (url, data, options = {}) => {
    const opt = { autoDealError: true, ...options };
    return service({
        url: url,
        method: 'put',
        data,
        ...opt,
    });
};

export const patch = (url, data, options = {}) => {
    const opt = { autoDealError: true, ...options };
    return service({
        url: url,
        method: 'patch',
        data,
        ...opt,
    });
};

export const downloadFile = async (url, data, ops = {}) => {
    ops.headers = getCommonHeaders();
    ops.headers['x-requested-with'] = true;
    ops.headers['xybbc_token'] = getToken();

    const _xhrId = utils.genId();
    loading.show(_xhrId);
    try {
        url = generatePrefixUrl(url, ops.urlPrefix);
        await download(getInternalReqUrl(url), data, ops);
    } catch (e) {
        console.log(e);
        MessageBox(e?.message || '下载发生错误');
    }
    loading.close(_xhrId);
};

/**
 * 上传文件
 * @param {File} file 传的是File raw格式
 */
export const upload = ({ file, url = clientConfig.uploadUrl }) => {
    const formData = new FormData();
    formData.append('file', file);
    return post(url, formData, {
        showLoading: true,
        catchBusinessErr: true,
        header: {
            ContentType: 'multipart/form-data',
            ...getCommonHeaders(),
        },
    });
};

/**
 * 默认headers
 */
export const getCommonHeaders = () => {
    let headers = {};
    const sellerAccessToken = getToken();
    const fsellerId = Cookies.get('fsellerId');
    headers = Object.assign(headers, { 'x-requested-with': true });
    if (sellerAccessToken) {
        headers['sellerAccessToken'] = sellerAccessToken;
        headers['accessToken'] = sellerAccessToken;
    }
    if (fsellerId) {
        headers['fsellerId'] = fsellerId;
    }
    // 1.微信 2.支付宝 3.银联 4.支付宝澳门 0.其他 server统一加
    // headers['originType'] = '0';
    return headers;
};
//

// import Qs from 'qs'
export const otherPost = (url, data, options = {}) => {
    // console.log(Qs.stringify(data))
    return service({
        url,
        data: data,
        method: 'post',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        accessToken: getToken(),
    });
};

service.otherPost = otherPost;
service.post = post;
service.get = get;
service.upload = upload;
service.downloadFile = downloadFile;

export default service;
